import React, { useContext, useEffect, useState } from "react";
import { Text, Space } from "react_reusable_components";
import { useIntl } from "react-intl";
import { TwoColumn } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";
import MyAccountsPopupContainer from "../MyAccountsPopupContainer/MyAccountsPopupContainer";
import ViewNotificationsPopupContainer from "../ViewNotificationsPopupContainer/ViewNotificationsPopupContainer";
import NotificationService from "../../services/notification-service";
import { GlobalLoaderContext } from "../../globalContext/globalLoader/globalLoaderProvider";
import { NotificationsContext } from "../../globalContext/notifications/notificationsProvider";

const AvatarNotificationContainerStyle = {
  style: {
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    gap: variables.gapSmall,
  },
  notify: {
    height: variables.notifyIcon,
    width: variables.notifyIcon,
    cursor: "pointer",
  },
  notificationCountStyle: {
    fontWeight: variables.fontWeightNormal,
    fontSize: "0.8rem",
    lineHeight: "100%",
    color: variables.bodyBg,
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    height: variables.fullHeight,
    justifyContent: variables.justifyCenter,
  },
  notificationWrapperStyle: {
    all: "unset",
    position: "relative",
  },
  notificationBellStyle: {
    width: "1.565rem",
    height: "1.565rem",
    backgroundColor: variables.primaryBg,
    borderRadius: variables.borderRadiusCircle,
    position: "absolute",
    top: "-0.52rem",
    right: "-1rem",
    display: variables.dFlex,
    justifyContent: variables.justifyCenter,
  },
};

export default function AvatarNotificationContainer() {
  const intl = useIntl();
  const loaderDispatch = useContext(GlobalLoaderContext)[1];

  const [openNotificationsPopup, setOpenNotificationsPopup] = useState(false);
  const [notificationState, notificationDispatch] =
    useContext(NotificationsContext);

  const handleOpenChange = (newOpen) => {
    setOpenNotificationsPopup(newOpen);
  };

  useEffect(() => {
    if (!openNotificationsPopup) return;
    NotificationService.getAllNotifications({
      dispatch: notificationDispatch,
      intl,
      loaderDispatch,
    });
  }, [intl, loaderDispatch, notificationDispatch, openNotificationsPopup]);

  const notificationsCount = notificationState.notificationsCount || 0;

  return (
    <TwoColumn
      style={AvatarNotificationContainerStyle.style}
      leftSection={
        <ViewNotificationsPopupContainer
          open={openNotificationsPopup}
          handleClose={() => setOpenNotificationsPopup(false)}
          handleOpenChange={handleOpenChange}
          icon={
            <Space
              size={0}
              style={AvatarNotificationContainerStyle.notificationWrapperStyle}
              onClick={() => setOpenNotificationsPopup((prev) => !prev)}
            >
              <img
                style={AvatarNotificationContainerStyle.notify}
                src="/icons/notifications.svg"
                alt="notify"
              />

              {!!notificationsCount && (
                <Space
                  size={0}
                  style={AvatarNotificationContainerStyle.notificationBellStyle}
                >
                  <Text
                    style={
                      AvatarNotificationContainerStyle.notificationCountStyle
                    }
                  >
                    {Number(notificationsCount) < 99
                      ? notificationsCount
                      : "99+"}
                  </Text>
                </Space>
              )}
            </Space>
          }
        />
      }
      rightSection={<MyAccountsPopupContainer />}
    />
  );
}
